export default "__VITE_ASSET__DqexpFxm__"